import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import { SCHEDULED_REPORTS_REPORT_ID } from './scheduledReportsReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.REPORT_NAME.field,
        FIELDS.FREQUENCY.field,
        FIELDS.DATE_RANGE.field,
        FIELDS.SENT_TO.field,
        FIELDS.LAST_MODIFY_BY.field,
        FIELDS.LAST_MODIFY_ON_UPDATE_TIME.field,
    ].map(field => generateColumnId(SCHEDULED_REPORTS_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.REPORT_NAME.field,
    FIELDS.FREQUENCY.field,
    FIELDS.DATE_RANGE.field,
    FIELDS.SENT_TO.field,
    FIELDS.LAST_MODIFY_BY.field,
    FIELDS.LAST_MODIFY_ON_UPDATE_TIME.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(SCHEDULED_REPORTS_REPORT_ID, field));

export { customColumns, defaultColumns };
